import { render, staticRenderFns } from "./wkTitle.vue?vue&type=template&id=c98c78b6&scoped=true"
import script from "./wkTitle.vue?vue&type=script&lang=js"
export * from "./wkTitle.vue?vue&type=script&lang=js"
import style0 from "./wkTitle.vue?vue&type=style&index=0&id=c98c78b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98c78b6",
  null
  
)

export default component.exports